/**
 * অবস্থা ১১ · অনুমোদন অপেক্ষমাণ — `E_APPROVAL_PENDING`.
 *
 * NO FRAME IS DRAWN FOR THIS STATE EITHER.
 *
 * Row 11 of the applicability matrix (line 779), `হ্যাঁ` on অ্যাক্টিভিটি and
 * অভ্যন্তরীণ — two cells — and a chip in `Architecture § 15` (line 905). The same two
 * mentions, no drawing, in any of the fifteen design files.
 *
 * It is the closest of the eleven to one that IS drawn: § ৯ · যাচাই অপেক্ষমাণ is a
 * waiting state with a three-step rail, a named duration and a "what still works"
 * list, and § অপেক্ষা ও প্রত্যাখ্যান gives waiting states their rule — "কতক্ষণ লাগবে,
 * আর এর মধ্যে কী করা যাবে". Close is not drawn, and the two differ in who is waiting
 * on whom: a verification waits on Oprappo, an approval waits on a named person, and
 * an approval screen that does not say whose decision it is would be a worse screen
 * than none. So no copy is written here. Reported.
 *
 * Note the neighbouring surface that IS built: WP-G's approval inbox (FM3) renders
 * approvals a founder is deciding. This state is the other side — the requester's
 * view while a decision is outstanding — and it is not the same screen.
 */
import { UndrawnPanel } from './chrome.js';
import { STATE_LABEL_BN } from './keys.js';

export interface ApprovalPendingStateProps {
  /**
   * `error.message_bn`, already localised. REQUIRED for the same reason as
   * `ServicePausedState`: there is no drawn sentence to fall back to.
   */
  messageBn: string;
  onBack?: (() => void) | undefined;
}

export function ApprovalPendingState({ messageBn, onBack }: ApprovalPendingStateProps): JSX.Element {
  return (
    <UndrawnPanel
      stateKey="approval_pending"
      headingBn={STATE_LABEL_BN.approval_pending}
      messageBn={messageBn}
      onBack={onBack}
    />
  );
}
